// this file contains a list of permission-names
// prettier-ignore
export default {
  WB_ADMIN:               1 << 0,  // = 1
  QA_ADMIN:               1 << 1,  // = 2
  QA_PROJECT_MANAGER:     1 << 2,  // = 4
  QA_SUPER_USER:          1 << 3,  // = 8
  USER_ADMIN:             1 << 4,  // = 16
  INVENTORY_ADMIN:        1 << 5,  // = 32
  COUNTING_REQUEST_ADMIN: 1 << 6,  // = 64
  INVENTORY_COUNTER:      1 << 7,  // = 128
  SYS_ADMIN:              1 << 8,  // = 256
} as const;
